import { GuestNavbar } from '@/components/GuestNavbar/GuestNavbar'
import { Box } from '@mantine/core'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/guest/')({
  component: IndexComponent,
})

function IndexComponent() {
  // Redirect to guest PIN entry by default
  return (
    <Box className="guest-layout">
      <GuestNavbar></GuestNavbar>
      <Outlet></Outlet>
    </Box>
  )
}
